import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output} from "@angular/core";
import {SharedService} from "../../services/sharedService";

@Component({
  selector: 'app-template-editor',
  template: `
    <textarea id="{{elementId}}"></textarea>
  `
})

export class TemplateEditor implements AfterViewInit, OnDestroy, OnChanges {

  @Input() elementId: string;
  @Input() tempValue: string;
  @Output() onEditorKeyup = new EventEmitter<any>();
  @Input() height;
  @Input() disableItem = false;

  constructor(private shared:SharedService){}

  ngAfterViewInit() {

    let this_ = this
    tinymce.init({
       toolbar: 'formatselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | outdent indent  | removeformat',
      readonly : this.disableItem,
      branding: false,
      promotion: false,
      selector: 'textarea#' + this.elementId,
      plugins: 'lists link image table code',
      entity_encoding : "raw",
      height: this.height,
      // images_upload_url: this.shared.getImageGeneralUploadUrl(),
      setup: (editor) => {
        editor.on("init", function () {
          if (this_.tempValue)
            this.setContent(this_.tempValue)
        });
        editor.on('Change', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
    });
  }

  ngOnChanges(changes: any): void {
    if (tinymce.get(this.elementId)){
      if (this.disableItem){
        tinymce.get(this.elementId).mode.set("readonly");
      }else{
        tinymce.get(this.elementId).mode.set("design");
      }
    }
  }

  ngOnDestroy() {
    tinymce.remove(tinymce.get(this.elementId))
  }
}
